module.exports = __webpack_public_path__ + "img/nom_outil.8bac3f73.jpg";